import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { fetchRegistration } from 'actions/challenge';
import LeaderboardContext from 'contexts/leaderboard';
import UserContext from 'contexts/user';
import DefaultLayout from 'layouts/default';
import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PublicUser } from 'types/user';
import './index.css';
const ProfilePage = () => {
  const { user } = useContext(UserContext);
  const { leaderboards, getChallenge, setLeaderboards } = useContext(
    LeaderboardContext
  );
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (user) {
      getChallenge(user.challenges.map(({ id }) => id)).then((leaderboards) => {
        setReady(true);
      });
    }
  }, [user]);
  const uniqueRegistrations: PublicUser['challenges'] = [];
  const challengeIdsVisited = new Set<string>();
  // user!.challenges.forEach((challenge) => {
  //   if (!challengeIdsVisited.has(challenge.id)) {
  //     challengeIdsVisited.add(challenge.id);
  //     uniqueRegistrations.push(challenge);
  //   }
  // });
  console.log({ leaderboards });
  return (
    <DefaultLayout>
      <div className="ProfilePage">
        <Typography variant="h4">Your Submissions</Typography>
        <Typography variant="body2">
          Shows every submission in each participated challenge, including
          submissions for a team or for yourself.
        </Typography>
        <div>If submissions do not show up, try refreshing the page.</div>
        <br />
        <section className="submissions">
          {ready && uniqueRegistrations.length === 0 && (
            <p>No submissions found</p>
          )}
          {ready &&
            Object.keys(leaderboards).map((value) => {
              let challenge = leaderboards[value];
              return (
                <div key={challenge.id}>
                  <Card className="card" elevation={3}>
                    <Link to={`/profile/submissions/${challenge.slug}`}>
                      <CardActionArea>
                        <CardContent>
                          <Typography variant="h5">
                            {challenge.name} Submissions
                          </Typography>
                          <Typography variant="body2">
                            {challenge.description}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Link>
                  </Card>
                </div>
              );
            })}
        </section>
      </div>
    </DefaultLayout>
  );
};

export default ProfilePage;
